/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  EstimationCostResponse,
  UpsertEstimationCostRequest,
  V1EstimationsCostsListError,
  V1EstimationsCostsUpdateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EstimationCost<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags EstimationCost
   * @name V1EstimationsCostsList
   * @summary Fetches estimation costs if already defined, otherwise returns empty response with HTTP 204.
   * @request GET:/api/v1/estimations/{estimationId}/costs
   * @secure
   * @response `200` `EstimationCostResponse` OK
   * @response `204` `void` No Content
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsCostsList = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<EstimationCostResponse, V1EstimationsCostsListError>({
      path: `/api/v1/estimations/${estimationId}/costs`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationCost
   * @name V1EstimationsCostsUpdate
   * @request PUT:/api/v1/estimations/{estimationId}/costs
   * @secure
   * @response `200` `EstimationCostResponse` OK
   * @response `400` `ProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsCostsUpdate = (
    estimationId: string,
    data: UpsertEstimationCostRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<EstimationCostResponse, V1EstimationsCostsUpdateError>({
      path: `/api/v1/estimations/${estimationId}/costs`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
